<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_register_content_area">
      <div class="row mb-5 justify-content-center">
        <div class="col-10">
          <enterprise-profile-form-new
            bg-color="gray"
            show-privacy-policy
            :registered-email="$route.query.email"
            @submit="submitProfile"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions
} from 'vuex'
import EnterpriseProfileFormNew from './EnterpriseProfileFormNew'
export default {
  name: 'EnterprisesRegisterContent',
  components: {
    EnterpriseProfileFormNew
  },
  methods: {
    ...mapActions('auth', [
      'addUserProfile'
    ]),
    async submitProfile (profile) {
      await this.addUserProfile({
        type: 'enterprise',
        profile: { ...profile, ...{ token: this.$route.query.token } }
      })
      this.$router.replace({
        path: `/login/enterprise`
      })
    }
  }
}
</script>
